import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./HeaderTarget.css";
import { useTranslation } from "react-i18next";
const HeaderTarget = ({ activePage }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab =
    activePage || (location.pathname === "/faq" ? "faq" : "need-help");

  const handleMobileSelect = (e) => {
    const selected = e.target.value;
    if (selected === "contact") navigate("/contact");
    else if (selected === "faq") navigate("/faq");
  };

  return (
    <>
      <section className="border-bottom">
        <div className="container-fluid">
          <div className="row" style={{ minHeight: "70px" }}>
            <div className="col-4 d-flex align-items-center">
              <p className="text-uppercase mt-3 mx-3">{t("NeedHelp")}</p>
            </div>

            {/* Desktop Tabs */}
            <div className="col-8 d-none d-sm-flex align-items-stretch justify-content-end px-0">
              <ul
                className="nav nav-tabs border-0"
                id="myTab"
                role="tablist"
                style={{ height: "100%" }}
              >
                {/* Need Help */}
                <li
                  className="nav-item"
                  role="presentation"
                  style={{ height: "100%", width: "150px" }}
                >
                  <a
                    href="/contact"
                    className={`nav-link rounded-0 fs-11 ${
                      activeTab === "need-help"
                        ? "active headertargetbttomcolor border-end-0"
                        : "border-start border-bottom-0 border-end-0"
                    }`}
                    role="tab"
                    aria-selected={activeTab === "need-help"}
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/contact");
                    }}
                  >
                    {t("NeedHelpTab")}
                  </a>
                </li>

                {/* FAQ */}
                <li
                  className="nav-item"
                  role="presentation"
                  style={{ height: "100%", width: "150px" }}
                >
                  <a
                    href="/faq"
                    className={`nav-link rounded-0 fs-11 ${
                      activeTab === "faq"
                        ? "active headertargetbttomcolor border-end-0"
                        : "border-0 border-start"
                    }`}
                    role="tab"
                    aria-selected={activeTab === "faq"}
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/faq");
                    }}
                  >
                    {t("FAQTab")}
                  </a>
                </li>
              </ul>
            </div>

            {/* Mobile Dropdown */}
            <div className="col-8 d-sm-none d-flex align-items-center justify-content-end px-3">
              <select
                className="form-select"
                style={{ maxWidth: "180px" }}
                value={activeTab}
                onChange={handleMobileSelect}
              >
                <option value="contact">{t("MobileOptionContact")}</option>
                <option value="faq">{t("MobileOptionFAQ")}</option>
              </select>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeaderTarget;
